import React from 'react';
import { useAuth } from '../context/AuthContext';

export default function Header() {
  const { user } = useAuth();

  if (!user) return null;

  const userName = user.firstName && user.lastName 
    ? `${user.firstName} ${user.lastName}` 
    : user.email;

    console.log("user:", user);
  
  const userRole = user.role_obj?.name || user.role || 'User';

  return (
    <div style={{
      position: 'absolute',
      top: '0px',
      right: '24px',
      display: 'flex',
      alignItems: 'center',
      gap: '16px',
      color: '#6B778C',
      fontFamily: 'inherit'
    }}>
      <div style={{ textAlign: 'right' }}>
        <div style={{
          fontSize: '14px',
          fontWeight: '500',
          color: '#42526E'
        }}>
          {userName}
        </div>
        <div style={{
          fontSize: '12px',
          color: '#8590A2',
          marginTop: '2px',
          textTransform: 'capitalize'
        }}>
          {userRole}
        </div>
      </div>
      <div style={{
        width: '40px',
        height: '40px',
        borderRadius: '50%',
        backgroundColor: '#DEE4EA',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '16px',
        fontWeight: '500',
        color: '#42526E',
        userSelect: 'none'
      }}>
        {userName.charAt(0).toUpperCase()}
      </div>
    </div>
  );
}
